import React from 'react';

export default function StatisticsCard({ title, value }) {
  return (
    <div className="bg-white rounded-lg p-5 shadow-sm border border-slate-200">
      <p className="text-xs uppercase tracking-wider font-semibold text-slate-500 mb-2">{title}</p>
      <p className="text-2xl font-bold text-slate-900 font-mono">{value ?? '—'}</p>
    </div>
  );
}
